/**
 * Thrown when the framework does not support loading a given resource type.
 * @extends Error
 */
export default class InvalidResourceTypeError extends Error {

    /**
     * Creates a new InvalidResourceType
     * @param {string} resourcePath the path of the src the loader was looking for.
     * @param {string} resourceType the type of resource the loader was trying to load.
     * @param {Error} innerError the error that originally threw.
     */
    constructor(resourcePath, resourceType, innerError) {
        super(`The resource type "${resourceType}" for resource "${resourcePath}" is not valid.`,
            innerError);
    }
}


// WEBPACK FOOTER //
// ./source/framework/errors/InvalidResourceTypeError.js